import { connect } from "react-redux";
var CurrentUser = require("lib/account/CurrentUser");
var DataSelectors = require("lib/selectors/DataSelectors");
var DownloadData = require("lib/data/DownloadData");

var Glyphicon = require("components/utility/icons/Glyphicon");
var ReactTooltip = require("react-tooltip");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var OrgTypes = require("lib/academic/OrgTypes");

require("data/date_span_selector.scss");

function propsToConditions(props) {
	var conditions = _.pick(props, 
		"startDate", "endDate"
	);

	return conditions;
}

@connect(
	(state, props) => ({
		userName: CurrentUser.get().display_name,
		dataExportF: DataSelectors.getDistrictExportDataF({ state }),
		schoolOrgs: RosterSelectors.schoolOrgs({ state }),
		studentLists: (
			props.orgIdentifier != OrgTypes.ALL_STUDENT_LISTS ?
			RosterSelectors.studentLists({ state, filters: { school_org_id: parseInt(OrgTypes.fromIdentifier(props.orgIdentifier).key) } }) :
			RosterSelectors.studentLists({ state })
		)
	})
)

class DownloadDataLink extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = this.getInitialState();
	}
	schools() {
		return _.sortBy(this.props.schoolOrgs, "name");
	}
	studentLists() {
		return _.sortBy(this.props.studentLists, "name");
	}
	getInitialState() {
		return {}
	}
	downloadData(e) {
		$wr.nope(e);
		var startDate = this.props.startDate;
		var endDate = this.props.endDate;
		var type = this.props.orgIdentifier;
		if (type == ALL_SCHOOLS) {
			var schools = this.schools();
			var toExport = this.props.dataExportF({ type: ALL_SCHOOLS, startDate, endDate, schools })
		} else if (type == ALL_CLASSES) {
			var studentLists = this.studentLists();
			var toExport = this.props.dataExportF({ type: ALL_CLASSES, startDate, endDate, studentLists })
		} else {
			var studentLists = this.studentLists();
			var toExport = this.props.dataExportF({ type: SCHOOL, startDate, endDate, studentLists })
		}
		var downloadFilename = _.compact(
			[this.props.userName, startDate, endDate, "stats"]
		).join(" - ") + ".csv";
		DownloadData.downloadCSV(toExport.rows, toExport.headers, downloadFilename);
	}

	render() {
		return (
			<span className="downloadDataLink">
				<a href="#" className="printLink hideOnPrint" onClick={ this.downloadData }>
					<Glyphicon icon="download-alt" dataTip="Download CSV" />
				</a>
			</span>
		);
	}
};

var ALL_SCHOOLS = "all-school-orgs";
var ALL_CLASSES = "all-student-lists";
var SCHOOL = "school-org";

DownloadDataLink.propTypes = StrictPropTypes({
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	orgIdentifier: PropTypes.string
});

module.exports = DownloadDataLink;



// WEBPACK FOOTER //
// ./modules/components/data/DownloadDataLink.js